<script setup lang="ts">
import {Loader2Icon} from 'lucide-vue-next'
import {ref} from "vue";
// @ts-nocheck
import {useCartStore} from "../../stores/cart";

const cartStore = useCartStore();
const open = ref(false)

interface Props {
    catalogUrl: string,
    cartUrl: string,
}

defineProps<Props>()

</script>

<template>

    <a :href="cartUrl" class="relative flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-primary transition hover:bg-primary-50/50 group">
        <span
            class="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs font-medium text-white">
            <Loader2Icon class="size-3 animate-spin text-primary-foreground" v-if="cartStore.isLoading"/>
            <span v-else>{{ cartStore.itemCount }}</span>
        </span>
        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
             title="Cart"
             stroke-linejoin="round">
            <circle cx="8" cy="21" r="1"/>
            <circle cx="19" cy="21" r="1"/>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
        </svg>
    </a>

</template>
